'use client'

import { Suspense } from 'react'
import { Base } from './Base/Base'
import { Menu } from './Menu/Menu'

export const PageHeader = () => (
  <div className="top-0 z-30 w-full bg-white lg:fixed">
    <Base />
    <Suspense>
      <Menu />
    </Suspense>
  </div>
)
